export { default } from './category-posts-section';
